import type { CSSProperties } from 'react';
import classnames from 'classnames';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Component } from '../elements/Component';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';
import { FormValidationMessage } from '../elements/FormValidationMessage';

interface ITextInputProps {
    autoFocus?: boolean;
    automation?: string;
    className?: string;
    descriptionText?: string;
    descriptionTextClassName?: string;
    disableClickPropagation?: boolean;
    disabled?: boolean;
    error?: string;
    id?: string;
    name?: string;
    onChange: (value: string) => void;
    onDoValidate?: (value?: string) => void;
    onEnter?: () => void;
    placeholder?: string;
    style?: CSSProperties;
    tabIndex?: number;
    trimValue?: boolean;
    value: string;
}

export class TextInput extends Component<FormContextProps<ITextInputProps>> {
    private changed = false;

    public render() {
        return (
            <FormContextConsumer {...this.props}>
                {(properties) => (
                    <div className="text-input">
                        <div className={properties.descriptionText ? ' form-control-inline' : ''}>
                            <input
                                autoFocus={properties.autoFocus ? properties.autoFocus : false}
                                className={classnames(
                                    'form-control',
                                    properties.className ? properties.className : '',
                                    properties.error ? ' form-control-danger' : '',
                                    this.props.automation ? 'automation-' + this.props.automation : ''
                                )}
                                disabled={properties.disabled}
                                id={properties.id}
                                name={properties.name}
                                onBlur={(e) => {
                                    if (properties.onDoValidate && this.changed) {
                                        properties.onDoValidate(e.target.value);
                                    }
                                }}
                                onChange={(e) => {
                                    this.changed = true;
                                    properties.onChange(properties.trimValue ? e.target.value.trim() : e.target.value);
                                }}
                                onClick={(e) => {
                                    if (this.props.disableClickPropagation) {
                                        e.preventDefault();
                                    }
                                }}
                                onKeyPress={(event) => {
                                    if (event.key === 'Enter' && properties.onEnter) {
                                        event.preventDefault();
                                        const target = event.target as HTMLInputElement;
                                        if (target.value) {
                                            properties.onChange(
                                                properties.trimValue ? target.value.trim() : target.value
                                            );
                                        }
                                        properties.onEnter();
                                    }
                                }}
                                placeholder={properties.placeholder}
                                style={properties.style}
                                tabIndex={this.props.tabIndex}
                                type="text"
                                value={properties.value}
                            />
                            {properties.descriptionText && (
                                <span
                                    className={classnames(
                                        'input-description',
                                        this.props.descriptionTextClassName || ''
                                    )}
                                >
                                    {properties.descriptionText}
                                </span>
                            )}
                        </div>
                        <FormValidationMessage error={properties.error} />
                    </div>
                )}
            </FormContextConsumer>
        );
    }
}

export function TextField(props: FormContextProps<ITextInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <TextInput {...props} />
        </Field>
    );
}
